import React from 'react';
import style from '../styles/users.module.scss';
import { Container } from '../components/content';
import { Card } from 'antd';
import PropTypes from 'prop-types';

const ContentLayout = ({ header, children, pt }) => {
  return (
    <Container className={style.users}>
      <Card className={`card-gradient ${pt ? 'pt-l' : ''}`}>
        {header && (
          <div className="card-gradient-wrapper">
            {typeof header === 'string' ? (
              <h1 className="text-2xl font-bold">{header}</h1>
            ) : (
              header
            )}
          </div>
        )}
        <div>{children}</div>
      </Card>
    </Container>
  );
};

ContentLayout.propTypes = {
  header: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node.isRequired,
  pt: PropTypes.bool,
};

export default ContentLayout;
